import { css } from '@compiled/react';

import { ConfluenceOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { JoinableSites } from '@/components/signup/site-activation/components/common/joinable-sites';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../../../components/headings';
import { JoinableSitesText } from '../../../components/joinable-sites-subheading';
import { WelcomeBackText } from '../../../components/welcome-back-heading.tsx';

export const CurrentProductJoinableUser = () => {
	return (
		<ConfluenceOverlayTemplate size="sm">
			<div css={containerCss}>
				<Headings main={<WelcomeBackText />} sub={<JoinableSitesText />} />
				<SiteActivation
					CurrentProductJoinableUser={<JoinableSites />}
					useContactExpandCohortLogic={true}
				/>
			</div>
		</ConfluenceOverlayTemplate>
	);
};

const containerCss = css({
	display: 'grid',
	gap: '10px',
});
